<template>
  <div class="chart-block" style="min-height:348px">
    <h3>   <a :href="url" target="_blank"> {{chartName}}</a> <span>{{updated}}</span></h3>
    <div class="sale-ls-block">
      <div class="sale-ls-row lbl">
        <div class="item">厂商简称</div>

        <div class="item" >子车型</div>
        <div class="item">工改模</div>
        <div class="item">上市日期</div>
      </div>
      <div class="sale-ls-row" v-for="( item,index) in tableData" :key="index">
        <div class="item sales-item"  style="flex:1.1">{{item.factory}} <el-badge class="mark" :value="item.count" style="left:-3px" /></div>
        <div class="item sales-model" style="flex:1.1">{{item.model}}  </div>
        <div class="item" style="flex:0.7">{{item.Engineering}}</div>
        <div class="item">
          <span class="pie">{{item.start}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";

import {strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
export default {
  data() {
    return {
      url:"",
      chartName: "新车上市",
      chartId :"new_car_start_market",
      updated:'',
      tableData: [],
    };
  },
  methods: {
     ...mapActions("home", ["queryChartConfigs", "queryChartUpdate","getChartList"]),
    updateChart() { 
        var info = this.getChartByName(this.chartId);
        this.tableData  = eval(info.jsonData);
        this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
    }
  },
  mounted(){
      this.getChartList({handle:this.updateChart});
  },
 computed: {
    ...mapGetters("home", {chartList: "chartList",getChartByName: "getChartByName"}),
  },
};
</script>
<style scoped>
.sale-ls-block {
  padding: 12px 20px;
  padding-top:0;
  margin-top: 0;
  font-size: 13px;
}
.sale-ls-row {
  display: flex;
  height: 50px;
  border-bottom: 1px dashed #ccc;
}
.sale-ls-row:last-child {
  border-bottom: none !important;
}
.sale-ls-row .item {
 
  padding: 20px 0;
  text-align:left;
  flex:1;
  width: 80px;
  white-space: nowrap; text-overflow:ellipsis; 
}
.lbl .item {
  font-weight: bolder;
}
.sale-ls-row .sales-item {
  font-size: 13px;
  font-weight: bolder;
  text-align: left;
  padding-left: 0;
 
}
.sale-ls-row .item .pie {
  display: inline-block;
  background-color: #47bae7;
  line-height: 22px;
  color: #fff;
  padding: 4px auto;
  padding-left:4px;
  width: 70px;
 
}
.sales-model{ font-size: .75em;  width:100px}
</style>